<script>

export default {
  name: 'dashboard-qualificacao-urcamp',
  data () {
    return {
      cursos: [
        {
          img: 'https://site.urcamp.edu.br/storage/images/images/16570c66873a3b1701889640.png',
          descricao: 'Noções de Libras',
          link: 'https://www.urcamp.edu.br/nocoes-de-libras'
        },
        {
          img: 'https://www.urcamp.edu.br/storage/images/images/165afa13701e3c1706008887.png',
          descricao: 'Gestão em Vendas',
          link: 'https://www.urcamp.edu.br/gestao-em-vendas'
        },
        {
          img: 'https://www.urcamp.edu.br/storage/images/images/165720202beea41701970434.png',
          descricao: 'Direito do Consumidor',
          link: 'https://www.urcamp.edu.br/direito-do-consumidor'
        },
        {
          img: 'https://www.urcamp.edu.br/storage/images/images/16570c93c277581701890364.png',
          descricao: 'Transtorno do Espectro Autista',
          link: 'https://www.urcamp.edu.br/transtorno-do-espectro-autista'
        },
        {
          img: 'https://www.urcamp.edu.br/storage/images/images/165c4be39d46981707392569.png',
          descricao: 'Vinhos e Harmonização',
          link: 'https://www.urcamp.edu.br/vinhos-e-harmonizacao'
        },
        {
          img: 'https://www.urcamp.edu.br/storage/images/images/16572302258ef81701982242.png',
          descricao: 'Veja mais cursos de Qualificação',
          link: 'https://www.urcamp.edu.br/ensino/qualificacao-urcamp-online'
        }
      ],
      currentIndex: 0
    }
  },
  methods: {
    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.cursos.length
    },
    prevSlide () {
      this.currentIndex = (this.currentIndex - 1 + this.cursos.length) % this.cursos.length
    },
    setSlide (index) {
      this.currentIndex = index
    }
  },
  mounted () {
    setInterval(this.nextSlide, 8000)
  }
}
</script>

<template>
    <div class="box box-25">
        <div class="box-header">
            <div class="box-title">Qualificações Urcamp Online</div>
        </div>
        <div class="box-content">
          <div class="carousel-container">
            <div class="carousel">
              <div class="carousel-item" v-for="(curso, index) in cursos" :key="index" v-show="currentIndex === index">
                <a :href="curso.link" target="_blank">
                  <img :src="curso.img" :alt="curso.descricao">
                  <div class="cursos-descricao">{{ curso.descricao }}</div>
                </a>
              </div>
            </div>
            <div class="carousel-pagination">
              <span v-for="(curso, index) in cursos" :key="index" :class="['bullet', { active: currentIndex === index }]" @click="setSlide(index)"></span>
            </div>
          </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
  .carousel-container {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .carousel {
    display: flex;
    overflow: hidden;
    justify-content: center;
    align-items: center;
  }

  .carousel-item {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    transition: transform 0.5s ease;
  }

  .carousel-item img {
    width: 60%;
    height: auto;
    border-radius: 8px;
  }

  .cursos-descricao {
    text-transform: uppercase;
    color: #595959;
    font-size: 15px;
    padding: 4px 0;
  }
  .carousel-pagination{
    text-align: center;
  }

  .bullet {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-color: #b3b3b3;
    border-radius: 50%;
    margin: 0 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .bullet.active {
    background-color: #000;
  }

  .bullet:hover {
    background-color: #7c7c7c;
  }
</style>



// WEBPACK FOOTER //
// QualificacaoUrcamp.vue?2698bd69